import moment from 'moment'
import * as RasaChromePicker from '../../../components/chrome-picker'
import * as Form from '../../../components/form'
import * as Modal from '../../../components/modal'
import * as Request from '../../../request'
import * as LeadTextTypes from '../types'
import * as Constants from './constants'
import * as Types from './types'
import * as Utils from './utils'

export type ToggleModal = Modal.Toggle
export const toggleModal = Modal.toggleModal(Constants.ADD_LEAD_TEXT_MODAL)

export type CloseModal = Modal.Close
export const closeModal = Modal.closeModal(Constants.ADD_LEAD_TEXT_MODAL)

export const FormActions = Form.createActionsMap(Constants.ADD_LEAD_TEXT_MODAL)

export type UpdateField = Form.UpdateField
export const updateField = FormActions[Form.UPDATE]

export type EnterEditActionCreator = (leadText: LeadTextTypes.LeadText, editType?: string) =>
  Form.FormAction<Form.Fields<Types.FormFields>>

export const enterEdit: EnterEditActionCreator = (leadText: LeadTextTypes.LeadText, editType: string = null) =>
  FormActions[Form.ENTER](
    {
      ...Utils.asFormFields(leadText),
      type: editType || (leadText.editor_state ? Constants.GUI_EDITOR : Constants.RAW_EDITOR),
    },
  )

type EditModalAction = (leadText: LeadTextTypes.LeadText) => Form.EnterAction<Types.FormFields>

export const onEdit: EditModalAction = (leadText: LeadTextTypes.LeadText, editType: string = null) => {
    const finalLeadText = editType === Constants.EDIT ? leadText : {...leadText, id: null}
    return enterEdit(finalLeadText)
}

export type SaveForm = Form.Save<Types.FormFields>
export const saveForm = FormActions[Form.SAVE]

const dateToDateString = (d: moment.Moment): string => {
  return (d && moment.isMoment(d)) ? d.toISOString().slice(0, 10) : null
}

const convertDates = (payload: any): any => {
  return {
    ...payload,
    end_date: dateToDateString(payload.end_date),
    start_date: dateToDateString(payload.start_date),
  }
}

export type PostLeadText = Request.Request
export const postLeadText: PostLeadText = (community, payload) =>
  Request.requestActionCreator<Request.RequestOptions<Types.FormFields>>(Constants.POST_LEAD_TEXT)({
    method: 'POST',
    payload: convertDates(payload),
    url: `/lead-text/${community}`,
  })

export type UpdateLeadText = Request.Request
export const updateLeadText: UpdateLeadText = (community: string, payloadData: any) => {
  const payload = Utils.transformIfRaw(payloadData)
  return (
    Request.requestActionCreator<Request.RequestOptions<Types.FormFields>>(Constants.PUT_LEAD_TEXT)({
      method: 'PUT',
      payload: convertDates(payload),
      url: `/lead-text/${community}/${payload.id}`,
    })
  )
}

export const updateEditorState = (editorState: any) => ({type: Constants.UPDATE_EDITOR_STATE, editorState})
export const handleColorChange = (type: Types.Type, color: RasaChromePicker.Color) =>
  ({ type: `LEAD_TEXT_${type}_COLOR_CHANGE`, color })

export const handleDropDownChange = (type: Types.Type, size: Types.Size) => ({ type: `LEAD_TEXT_${type}_CHANGE`, size })



// WEBPACK FOOTER //
// ./src/pages/lead-text/add-edit-modal/actions.ts